import { DateInput } from "@msuite/ui/date-input";
import { Select, TextInput } from "@msuite/ui/form";
import { useTranslation } from "@msuite/ui/localization";
import type { IncomingInvoiceSchema } from "@msuite/utils/schemas";
import { useFormContext } from "react-hook-form";
import { ContactPicker } from "@/components/contacts";
import { INCOMING_INVOICE_KIND_LABEL } from "@/components/incoming-invoices/incoming-invoice-kind-labels";
import { WorkspacePicker } from "@/components/pickers/workspace-picker";

/** The invoice itself: what kind, its number and dates, and what it is booked to. */
export function IncomingInvoiceFormGeneral() {
	/** Context */
	const methods = useFormContext<IncomingInvoiceSchema>();

	/** Hooks */
	const { t } = useTranslation();

	/** Computed */
	const kindOptions = Object.entries(INCOMING_INVOICE_KIND_LABEL).map(([value, label]) => ({
		value: value as IncomingInvoiceSchema["kind"],
		label: t(label),
		item: null,
	}));

	/** Render */
	return (
		<div className="v-stack gap-4">
			<p className="label">{t("incoming_invoices.invoice")}</p>
			<div className="grid grid-cols-2 gap-4">
				<Select
					control={methods.control}
					name="kind"
					label={t("incoming_invoices.kind_label")}
					isRequired
					isNullable={false}
					options={kindOptions}
					data-cy="incoming-invoice-kind-select"
				/>
				<TextInput
					control={methods.control}
					name="number"
					label={t("incoming_invoices.number")}
					isRequired={false}
					data-cy="incoming-invoice-number-input"
				/>
				<DateInput
					control={methods.control}
					name="invoiceDate"
					label={t("incoming_invoices.invoice_date")}
					isNullable
				/>
				<DateInput
					control={methods.control}
					name="dueDate"
					label={t("incoming_invoices.due_date")}
					isNullable
				/>
			</div>
			<WorkspacePicker
				methods={methods}
				control={methods.control}
				name="workspaceId"
			/>
			<ContactPicker
				control={methods.control}
				name="contactId"
				label={t("incoming_invoices.contact")}
				isNullable
			/>
			<TextInput
				control={methods.control}
				name="reportNumber"
				label={t("incoming_invoices.report_number")}
				isRequired={false}
			/>
		</div>
	);
}
